var _mask, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlagAm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 36,
    height: 36
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.9424 35.8848C27.8517 35.8848 35.8848 27.8517 35.8848 17.9424C35.8848 8.03308 27.8517 0 17.9424 0C8.03308 0 0 8.03308 0 17.9424C0 27.8517 8.03308 35.8848 17.9424 35.8848Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.9424 35.8848C27.8517 35.8848 35.8848 27.8517 35.8848 17.9424C35.8848 8.03308 27.8517 0 17.9424 0C8.03308 0 0 8.03308 0 17.9424C0 27.8517 8.03308 35.8848 17.9424 35.8848Z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.872 0H-2.65813V11.9616H39.872V0Z",
    fill: "#FA0002"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.872 11.9614H-2.65813V23.923H39.872V11.9614Z",
    fill: "#0A00D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.872 23.9233H-2.65813V35.8849H39.872V23.9233Z",
    fill: "#FDAB05"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagAm);
export default __webpack_public_path__ + "static/media/flag-am.2984ca78fd673cf5a749854da64511f2.svg";
export { ForwardRef as ReactComponent };